/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { getClientHints } from '../PRIVATE_clientHints';

const clientHints = getClientHints();

/**
 * Checks if the key pressed is the backspace/delete key.
 *
 * @param event The keyboard event
 * @return the result of the check
 */
export function isBackspaceOrDelete(event: KeyboardEvent) {
  return event.code === 'Backspace' || event.code === 'Delete';
}

/**
 * Checks if the current event is a select-all event
 *
 * @param event The keyboard event
 * @returns the result of the check
 */
export function isSelectAll(event: KeyboardEvent) {
  return (
    ((clientHints.platform === 'mac' && event.metaKey) ||
      (clientHints.platform === 'windows' && event.ctrlKey)) &&
    event.code === 'KeyA'
  );
}
